import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Category, FeedState} from "../../common/types/feed";

const initialState: FeedState = {
    categories: [],
    canGenerateFeed: false,
    canViewFeed: false,
};

const feedSlice = createSlice({
    name: 'feed',
    initialState,
    reducers: {
        setCategories(state, action: PayloadAction<Category[]>) {
            state.categories = action.payload;
        },
        toggleCategory(state, action: PayloadAction<string>) {
            const category = state.categories.find((cat) => cat.id === action.payload);
            if (category) {
                category.selected = !category.selected;
            }
        },
        resetCategories(state) {
            state.categories.forEach((cat) => (cat.selected = false));
        },
        setCanGenerateFeed(state, action: PayloadAction<boolean>) {
            state.canGenerateFeed = action.payload;
        },
        setCanViewFeed(state, action: PayloadAction<boolean>) {
            state.canViewFeed = action.payload;
        },
    }
});

export const {
    setCategories,
    toggleCategory,
    resetCategories,
    setCanGenerateFeed,
    setCanViewFeed
} = feedSlice.actions;

export default feedSlice.reducer;
